<br>
<br>
<br>

<div class="container">
  <br />
  <div class="col-md-6 col-md-offset-3" id="login">
    <div class="panel panel-default">
      <div class="panel-heading">
        <a class="centrado"><img src="./assets/img/cnsf_azul.jpeg"></a>
        <br><br><br>
        <label class="panel-title">
          Inicio de Sesión</label>
      </div>
      <br>
      <div class="row">
        <form [formGroup]="loginForm" #login="ngForm">
          <div class="col-md-7 col-md-offset-3" id="login">
            <md-input-container style="width:100%; margin-bottom: 10px;" [ngClass]="{'mat-input-invalid': summited && error?.code == 1}">
              <div class="form-group">
                <label class="user"> Usuario </label>
                <div class="input-group">
                  <span class="input-group-addon" id="iconn"> <i class="fa fa-user"></i></span>
                  <input type="text" class="form-control" value="" name="usuario" id="usuario"
                  placeholder="Ingrese Usuario" autocomplete="off" formControlName="usuario"/>
                  
                </div>
              </div>
            <md-hint style="color: red;" *ngIf="summited && error?.code == 1 && !loginForm.controls.usuario.hasError('required') " >{{error.message}}</md-hint>
            <md-hint style="color: red;" *ngIf="summited && loginForm.controls.usuario.hasError('required')" >Campo Login es Requerido</md-hint>
          </md-input-container>
          <md-input-container style="width:100%; margin-bottom: 10px;" [ngClass]="{'mat-input-invalid': summited && error?.code == 1}">
            <div class="form-group">
              <label class="user"> Contraseña </label>
              <div class="input-group">
                <span class="input-group-addon" id="iconn1"> <i class="fa fa-lock"></i></span>
                <input type="password" class="form-control" value="" name="ingreso" id="ingreso"
                  placeholder="Ingrese contraseña" autocomplete="off" formControlName="ingreso"/>
                  
              </div>
            </div>
            <md-hint style="color: red;" *ngIf="summited && error?.code == 1 && !loginForm.controls.ingreso.hasError('required') " >{{error.message}}</md-hint>
            <md-hint style="color: red;" *ngIf="summited && loginForm.controls.ingreso.hasError('required')" >Campo Contraseña es Requerido</md-hint>
          </md-input-container>
            <div class="form-group text-center">
              <button id="btnSubmit" mat-raised-button type="submit" class="btn btn-primary my-2" [disabled]="!login.form.valid" (click)="submitLogin()">Acceder</button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12" style="text-align: center;">
                <button tabindex="5" class="btn btn-link" (click)="mostrarModal()">¿No recuerdas tu contraseña? </button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>

<br>
<br>
<br>

<div #modal class="modal" tabindex="1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Restablecer contraseña</h4>
      </div>
      <div class="modal-body">
        <form role="form" [formGroup]="formRestablecer">
          <div class="row">
            <label class="user"> Usuario </label>
            <div class="input-group">
              <span class="input-group-addon" id="iconn"> <i class="fa fa-user"></i></span>
              <input type="text" class="form-control" name="user" id="user" formControlName="user" placeholder="Ingrese Usuario" autocomplete="off" required/>
            </div>
            <small style="color: red;" *ngIf="!isEmail">Formato incorrecto</small>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cerrarModal()">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="formRestablecer.invalid" (click)="restablecerPassword()">Enviar correo</button>
      </div>
    </div>
  </div>
</div>


